import React from 'react';
import styled from 'styled-components';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { breakpoints } from '@/components/responsive';

export interface StrapiMetricProps {
  metricValue: string;
  metricName: string;
  metricImage: string;
}

export function StrapiMetric({
  metricValue,
  metricName,
  metricImage,
}: StrapiMetricProps) {
  return (
    <Wrapper>
      <div className="separator" />
      <StrapiTextual className="value" text={metricValue} />
      <div />
      <div className="name-wrapper">
        <StrapiTextual className="name" text={metricName} />
        <img src={metricImage} alt="" />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  align-content: center;
  grid-template-columns: auto 1fr;
  grid-column-gap: 3.3rem;
  grid-row-gap: 1rem;
  font-family: Eesti, serif;

  ${breakpoints.down(`md`)} {
    margin-left: 2rem;
  }

  .separator {
    ${breakpoints.down(`md`)} {
      display: none;
    }
    border-radius: 0.5rem;
    width: 0.4rem;
    background-color: rgba(0, 0, 0, 0.05);
  }

  .name-wrapper {
    display: flex;
    align-items: baseline;

    ${breakpoints.down(`md`)} {
      display: grid;
      grid-template-columns: max-content auto;
    }
  }

  .value {
    text-align: start;
    font-size: 5.5rem;
    color: black;
    font-weight: 300;

    ${breakpoints.down(`md`)} {
      font-size: 4rem;
      text-align: center;
    }
  }

  .name {
    margin-right: 2rem;
    text-align: start;
    font-size: 2rem;
    color: black;
    font-weight: 300;

    ${breakpoints.down(`md`)} {
      font-size: 1.6rem;
      margin-left: 3rem;
    }
  }

  img {
    height: 2.4rem;
    width: auto;
    object-fit: contain;

    ${breakpoints.down(`md`)} {
      height: 1.8rem;
    }
  }
`;
